export enum RouteNames {
  InferenceMonitoring = 'InferenceMonitoring',
  Monitoring = 'Monitoring',
  PlatformConnections = 'PlatformConnections',
}
